import Feature from 'Services/Feature';

export default {
    computed: {
        isOutboxTable() {
            return this.$route.name === 'emails.outbox';
        },
        isSentTable() {
            return this.$route.name === 'emails.sent';
        },
        isReceivedTable() {
            return this.$route.name === 'emails.received';
        },
        isScheduledTable() {
            return this.$route.name === 'emails.scheduled';
        },
        isReceivedTableOrSentTable() {
            return this.isReceivedTable || this.isSentTable;
        },
    },
    methods: {
        openEmailPanel(email) {
            if (Feature.isEnabled('email-engine')) {
                if (this.isOutboxTable || this.isScheduledTable) {
                    const dataPanel = {
                        email: email,
                        thread: [],
                    };
                    this.$trigger('emailPreviewPanel:new', dataPanel);
                }

                if (this.isReceivedTable || this.isSentTable) {
                    const readProviderThreadLink = email._links.find(
                        (link) => link.rel === 'thread.read',
                    )?.href;
                    const dataPanel = {
                        email: {
                            threadId: email.provider_thread_id,
                            subject: email.subject,
                        },
                        isFromProvider: true,
                        readProviderThreadLink: readProviderThreadLink,
                    };
                    this.$trigger('emailConsultPanel:new', { oneLog: dataPanel });
                }
            }
        },
        canReadEmail(emailLinks) {
            return emailLinks.some((link) => link.rel === 'thread.read');
        },
        canUpdateEmail(emailLinks) {
            return emailLinks.some((link) => link.rel === 'thread.update');
        },
        canUpdateRelated(emailLinks) {
            return emailLinks.some((link) => link.rel === 'thread.update_related_batch');
        },
    },
};
